export class DataInput {
  idPratica: string;
  idFascicolo: string;
  posizionePratica: string;
  posizioneFascicolo: string;
  tipoPratica: string;
  constructor(idPratica: string, idFascicolo: string, posizionePratica: string, posizioneFascicolo: string, tipoPratica: string) {
    this.idPratica = idPratica;
    this.idFascicolo = idFascicolo;
    this.posizionePratica = posizionePratica;
    this.posizioneFascicolo = posizioneFascicolo;
    this.tipoPratica = tipoPratica;
  }
}
